import { connect } from 'react-redux';
import React from 'react';
import {
    HeaderContainer as SourceHeaderContainer,
    mapStateToProps,
    mapDispatchToProps,
    DEFAULT_HEADER_STATE,
} from 'SourceComponent/Header/Header.container';
import Header from './Header.component';

export {
    mapStateToProps,
    mapDispatchToProps,
    DEFAULT_HEADER_STATE,
};

export class HeaderContainer extends SourceHeaderContainer {
    render() {
        // for homepage appointment popup
        // const bookappoinetment = document.getElementsByClassName("book-appointment-container");

        // if (bookappoinetment?.length > 0) {
        //     bookappoinetment[0].onclick = function () {
        //         const bookappoinetmentmodel = document.getElementById("appointment-popup");
        //         if (bookappoinetmentmodel) {
        //             bookappoinetmentmodel.style.display = "flex";

        //             const bookappoinetmentmodelcloseicon = document.getElementsByClassName("appointment_closeIcon");
        //             if (bookappoinetmentmodelcloseicon?.length > 0) {
        //                 bookappoinetmentmodelcloseicon[0].onclick = function () {
        //                     bookappoinetmentmodel.style.display = "none";
        //                 }
        //             }
        //         }
        //     }
        // }

        // const bookappoinetmentssw = document.getElementById("appointment");

        // if (bookappoinetmentssw) {
        //     bookappoinetment.onclick = function () {
        //         const bookappoinetmentmodel = document.getElementById("appointment-popup");
        //         if (bookappoinetmentmodel) {
        //             bookappoinetmentmodel.style.display = "flex";

        //             const bookappoinetmentmodelcloseicon = document.getElementsByClassName("appointment_closeIcon");
        //             if (bookappoinetmentmodelcloseicon?.length > 0) {
        //                 bookappoinetmentmodelcloseicon[0].onclick = function () {
        //                     bookappoinetmentmodel.style.display = "none";
        //                 }
        //             }
        //         }
        //     }
        // }

        return (
            <Header
                {...this.containerProps()}
                {...this.containerFunctions}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);
